<template>
  <div>
    <span class="ml-5">{{name}}</span>
    <a v-if="showExternalLink" :href="link" target="_blank" class="ml-5">
      <i class="mdi mdi-open-in-new" />
    </a>
  </div>
</template>
<script>

import ProductUtil from '@/utils/product-util'

export default {
  name: 'Inventory-product-tile',
  props: {
    product: {
      type: Object,
      default: null,
    },
    vintage: {
      type: String,
      default: null
    },
    inventoryCode : {
      type: String,
      default: null
    }
	},
  data() {
    return {

    };
  },components: {

  },
	methods: {

	},
	computed: {
    showExternalLink () {
      return this.inventoryCode === 'SAQ';
    },
    link (){
      return `https://app.datagrapes.io/products/${this.productExternalId}/synthesis`;
    },
    productExternalId (){
      return _.get(this.product, 'externalId');
    },
    name(){
      return this.product.extendedName;
    },
	},
	watch : {

	},
	mounted(){

	},
	created(){

	}
}
</script>

<style lang="scss" scoped>

</style>
